export const brand1 = [
  {
    id: "b0101",
    brand: "OATLY",
    name: "原味燕麥奶",
    img: "/images/productDB/product-1-1.png",
    introImg: "/images/productDB/intro-1-1.png",
    price: "1314"
  },
  {
    id: "b0102",
    brand: "OATLY",
    name: "咖啡師燕麥奶",
    img: "/images/productDB/product-1-2.png",
    introImg: "/images/productDB/intro-1-2.png",
    price: "1314"
  },
  {
    id: "b0103",
    brand: "OATLY",
    name: "巧克力燕麥奶",
    img: "/images/productDB/product-1-3.png",
    introImg: "/images/productDB/intro-1-3.png",
    price: "1314"
  }
];

export const brand2 = [
  {
    id: "b0201",
    brand: "CALIFA FARMS",
    name: "咖啡師燕麥奶",
    img: "/images/productDB/product-2-1.png",
    introImg: "/images/productDB/intro-2-1.png",
    price: "1200"
  },
  {
    id: "b0202",
    brand: "CALIFA FARMS",
    name: "濃醇燕麥奶",
    img: "/images/productDB/product-2-2.png",
    introImg: "/images/productDB/intro-2-2.png",
    price: "1350"
  },
  {
    id: "b0203",
    brand: "CALIFA FARMS",
    name: "高蛋白燕麥奶",
    img: "/images/productDB/product-2-3.png",
    introImg: "/images/productDB/intro-2-3.png",
    price: "1520"
  }
];

export const brand3 = [
  {
    id: "b0301",
    brand: "MINOR FIGURES",
    name: "咖啡師燕麥奶",
    img: "/images/productDB/product-3-1.png",
    introImg: "/images/productDB/intro-3-1.png",
    price: "1214"
  },
  {
    id: "b0302",
    brand: "MINOR FIGURES",
    name: "低脂燕麥奶",
    img: "/images/productDB/product-3-2.png",
    introImg: "/images/productDB/intro-3-2.png",
    price: "1314"
  },
  {
    id: "b0303",
    brand: "MINOR FIGURES",
    name: "濃厚燕麥奶",
    img: "/images/productDB/product-3-3.png",
    introImg: "/images/productDB/intro-3-3.png",
    price: "1400"
  }
];

export const brand4 = [
  {
    id: "b0401",
    brand: "OATSIDE",
    name: "職人燕麥奶",
    img: "/images/productDB/product-4-1.png",
    introImg: "/images/productDB/intro-4-1.png",
    price: "165"
  },
  {
    id: "b0402",
    brand: "OATSIDE",
    name: "巧克力榛子燕麥奶",
    img: "/images/productDB/product-4-2.png",
    introImg: "/images/productDB/intro-4-2.png",
    price: "165"
  },
  {
    id: "b0403",
    brand: "OATSIDE",
    name: "巧克力燕麥奶",
    img: "/images/productDB/product-4-3.png",
    introImg: "/images/productDB/intro-4-3.png",
    price: "165"
  }
];
